export var enUS = 'en-US';
export var esMX = 'es-MX';
export var defaultLocale = enUS;
export var STATIC_NAMESPACE = 'translation';
export var SETTINGS_NAMESPACE = 'partnerSettings';
export var WIDGET_NAMESPACE = 'widget';
export var EMERGENCY_BANNER_NAMESPACE = 'emergencyBanner';
// Unused on frontend:
// export const OPTION_NAMESPACE = 'questionOptions' as const;
// export const HELPER_NAMESPACE = 'questionHelpers' as const;
export var frontendNamespaces = [
    STATIC_NAMESPACE,
    SETTINGS_NAMESPACE,
    WIDGET_NAMESPACE,
    EMERGENCY_BANNER_NAMESPACE,
];
